module.exports = __webpack_public_path__ + "img/advan-three.b556968c.png";